import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAdmin } from "@/context/AdminContext";

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const to = location.state?.from?.pathname || "/admin";
      navigate(to, { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Autentificare eșuată");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.19, 1, 0.22, 1] }}
        className="w-full max-w-md"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-full border border-black/15 flex items-center justify-center">
            <Lock className="w-5 h-5 text-[#0E0F12]" strokeWidth={1.4} />
          </div>
          <div>
            <p className="font-serif text-2xl leading-none">Panou Admin</p>
            <p className="text-xs tracking-[0.3em] uppercase text-[#4A4844] mt-1">deter-ecobox.ro</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-[11px] tracking-[0.2em] uppercase text-[#4A4844] mb-2">Email</span>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-b border-black/20 focus:border-gramur outline-none py-2.5 text-[#0E0F12] text-sm transition-colors"
            />
          </label>
          <label className="block">
            <span className="block text-[11px] tracking-[0.2em] uppercase text-[#4A4844] mb-2">Parolă</span>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-black/20 focus:border-gramur outline-none py-2.5 text-[#0E0F12] text-sm transition-colors"
            />
          </label>

          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-4 bg-[#0E0F12] text-[#EDEAE3] text-sm tracking-widest uppercase rounded-sm hover:-translate-y-[2px] transition-transform duration-300 disabled:opacity-60"
          >
            {loading ? "Se conectează…" : "Autentificare"}
          </button>
        </form>

        <button onClick={() => navigate("/")} className="mt-8 text-xs tracking-widest uppercase text-[#4A4844] hover:text-[#0E0F12] transition-colors">
          ← Înapoi la magazin
        </button>
      </motion.div>
    </main>
  );
}
